import YearlyStatement from 'features/advance/screens/manageAdvanceAccount/advanceStatements/YearlyStatement/YearlyStatement';
import React from 'react';

export default function YearlyStatementPage() {
  return <YearlyStatement />;
}
